import {ErrorType} from "./error-type";
import FieldProto from "../../fields3/proto/field-proto";
import ErrorProto from "./error";

export default class ErrorFieldIncorrectValue extends ErrorProto {

    public field  : FieldProto

    constructor(field:FieldProto) {
        super()

        this.type       = ErrorType.FieldIncorrectValue
        this.field      = field
    }

    get message() {
        return "Field "+this.field.label+" value is incorrect"
    }


}